import { render } from "./TypoText.vue?vue&type=template&id=65bf95a4&scoped=true"
import script from "./TypoText.vue?vue&type=script&lang=js"
export * from "./TypoText.vue?vue&type=script&lang=js"

import "./TypoText.vue?vue&type=style&index=0&id=65bf95a4&scoped=true&lang=css"

import exportComponent from "/Volumes/Storage/WebDevelopment/Fintax/new-gitlab/pajak.io/frontend-library-component-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65bf95a4"]])

export default __exports__